module.exports = __webpack_public_path__ + "static/img/14.a1c52da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/14.png
// module id = Mw5j
// module chunks = 0